import styled from 'styled-components';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const SuccessIconContainer = styled.div `
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(#d82792, #3621b6);
  background: radial-gradient(128.44% 143.02% at 96.27% -10.78%, #d82792 0%, #3621b6 100%);
  color: #fdfcfb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;
export const Text = styled.div `
  margin-top: 12px;
`;
export const ButtonsContainer = styled.div `
  width: 100%;
  margin-top: 24px;
  gap: 12px;
  display: flex;
  flex-direction: column;
`;
